<div class="local-spinner">
  <div></div>
</div>
